import Resource from "../base/resource";

class Style extends Resource {
    properties;

    constructor(props) {
        super(props);
        this.properties = props.properties ? props.properties : props;
    }

    load(onLoadCallback) {
        if (wv.effectController.stoppedTrainingId === TrainingTreeController._trainingFeature.getActiveTraining()?.id) {
            return;
        }
        onLoadCallback(1);
    }

    getDefaultState() {
        return {
        };
    }
}

export default Style;
